
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d)"}},[_c('path',{attrs:{"d":"M33 11L15.125 29 7 20.818","stroke":"#fff","stroke-width":"5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d","x":"-3.797","y":"0","width":"47.594","height":"48.618","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset',{attrs:{"dy":"4.82"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"1.899"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0894161 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    